'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'sunrise';
var width = 576;
var height = 512;
var aliases = [127749];
var unicode = 'f766';
var svgPathData = 'M551.1 463.1L491.5 464l29.38-44.75c7.375-11.12 8.75-25.25 3.625-37.75c-5.25-12.38-16.12-21.5-29.25-24.25l-70.75-14.5L410 272c-2.75-13.25-11.75-24.25-24.25-29.38c-12.5-5.25-26.62-3.75-37.63 3.625L287.8 286L227.6 246.1c-22.5-14.88-56.5-.875-61.88 25.62l-14.5 70.88L80.63 357c-13.38 2.75-24.12 11.75-29.38 24.25c-5 12.5-3.75 26.5 3.75 37.75L84.75 464l-60.75-.0065C10.8 463.1 0 474.8 0 487.1S10.8 512 24 512H551.1C565.2 512 576 501.2 576 487.1S565.2 463.1 551.1 463.1zM234.6 464c4.625-15.62 16-29 32.13-35.75c28.5-11.75 61.5 1.875 73.25 30.38c.75 1.75 1.125 3.625 1.625 5.375H234.6zM434 464h-43.25c-1.25-8-3.125-16-6.375-23.75c-21.88-53-82.88-78.25-135.9-56.38C213.8 398.3 191.1 429.4 185.8 464h-43.5l-40.88-62.13l90.88-18.62l18.5-90.88l77.38 51.25l77.25-51.13l18.75 90.88l90.75 18.75L434 464zM224.1 120.1L264 81.94V200C264 213.3 274.8 224 288 224s24-10.75 24-24V81.94l39.03 39.03C355.7 125.7 361.9 128 368 128s12.28-2.344 16.97-7.031c9.375-9.375 9.375-24.56 0-33.94l-80-80c-9.375-9.375-24.56-9.375-33.94 0l-80 80c-9.375 9.375-9.375 24.56 0 33.94S215.6 130.3 224.1 120.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSunrise = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;